import color from "../../../constants/color";

const style = {
  container: {
    px: "15px",
    py: 2,
    backgroundColor: "#F1F1F1",
    minHeight: "100vh",
  },
  title: {
    fontWeight: 600,
    fontSize: "24px",
    color: color.text,
    mb: 0.5,
  },
  subtitle: {
    fontSize: "14px",
    color: color.lightText,
    mb: 3,
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
    p: 3,
    mb: 3,
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: 600,
    color: color.text,
    mb: 2,
  },
  fieldLabel: {
    fontSize: "14px",
    fontWeight: 500,
    color: color.text,
    mb: 0.5,
  },
  helperText: {
    fontSize: "12px",
    color: color.lightText,
    mt: 0.5,
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 2,
    mt: 3,
  },
  saveButton: {
    backgroundColor: color.primary,
    color: "#fff",
    borderRadius: "50px",
    textTransform: "none",
    px: 4,
    py: 1,
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "#228A3A",
    },
  },
  cancelButton: {
    borderRadius: "50px",
    textTransform: "none",
    px: 4,
    py: 1,
    fontWeight: 500,
  },
};

export default style;
